<template>
  <text-string :label-id="labelId" :props="textStringProps" />
</template>

<script>
  import {
    STATUS_CODES,
    DEFAULT_PHARMACIES,
  } from '@/reference/medicine';
  import ToastMixin from '@/mixins/toast-mixin';
  import CDEventBusMixin from '@/mixins/content-dictionary-event-bus-mixin';
  import {
    REGINE_NUMBER,
  } from '@/reference/medicine';

  export default {
    name: 'order-status-text',
    mixins: [
      CDEventBusMixin,
      ToastMixin,
    ],
    props: {
      order: {type: Object, required: true},
    },
    data() {
      return {
        targetCDEvents: [
          {
            id: 'txt196$1',
            handler: this.txt196$1Handler,
          },
        ],
      }
    },
    computed: {
      labelId() {
        switch (this.order.status) {
          case STATUS_CODES.PENDING:
          case STATUS_CODES.FOR_FOLLOW_UP: {
            return this.order.partnercode === DEFAULT_PHARMACIES.NS_PHARMACY ? 'txt211' : 'txt122';
          }
          case STATUS_CODES.PROCESSING:
          case STATUS_CODES.DELIVERING: {
            return this.order.partnercode === DEFAULT_PHARMACIES.NS_PHARMACY ? 'txt208' : 'txt230';
          }
          case STATUS_CODES.CONFIRMED: {
            return 'txt230';
          }
          case STATUS_CODES.AWAITING_PAYMENT: {
            return this.order.partnercode === DEFAULT_PHARMACIES.NS_PHARMACY ? 'txt196' : 'txt122';
          }
          case STATUS_CODES.FULFILLED: {
            return 'txt230';
          }
          case STATUS_CODES.PROC_FAILED_DELIVERY: {
            return 'txt230';
          }
          default: {
            return 'txt230';
          }
        }
      },
      textStringProps() {
        if (this.order.status === STATUS_CODES.AWAITING_PAYMENT && this.order.partnercode === DEFAULT_PHARMACIES.NS_PHARMACY) {
          const finalPaymentLink = this.order.paymentlink || REGINE_NUMBER;
          return {
            strings: [finalPaymentLink],
            numbers: [this.order.amount],
            functions: {
              $1: this.getEventEmitId('txt196$1', {paymentlink: finalPaymentLink}),
            },
          };
        }

        return {};
      },
    },
    methods: {
      txt196$1Handler({paymentlink}) {
        if (paymentlink.includes('http')) {
          window.open(paymentlink, '_blank');
        } else {
          navigator.clipboard.writeText(paymentlink)
            .then(() => {
              this.showToast({
                text: `Copied ${paymentlink} to clipboard`,
                theme: 'success',
              });
            });
        }
      },
    },
  }
</script>

<style>

</style>
